import React from "react";
import store from '../../../store/configureStore';
import { connect } from "react-redux";

class Msg extends React.Component {
    render() {
      
        const key = this.props.phrase;

        const state = store.getState();
        if (state.olxstore.storeOpts.customTranslation) {
            if (state.olxstore.storeOpts.customTranslation[key]) {
                return <span dangerouslySetInnerHTML={{ __html: state.olxstore.storeOpts.customTranslation[key] }} />;
            }
        }

        const phrase = this.props.phrases[key] || key;
        return <span>{phrase}</span>;
    }
}

const mapStateToProps = state => state.i18n;

export default connect(mapStateToProps)(Msg);
